/* eslint-disable */
export default {
  from: 'De',
  to: 'Para',
  enterNameOrNumber: 'Insira o número ou o nome...',
  typeMessage: 'Digite a mensagem…',
  send: 'Enviar',
  emoji: 'Emoji',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
